import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getList, getCode, build, remove, add, update, copy } from "@/api/tool/code";
import { mapGetters } from "vuex";
export default {
  data: function data() {
    return {
      form: {},
      selectionList: [],
      loading: true,
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      option: {
        height: 'auto',
        calcHeight: 30,
        dialogWidth: 900,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        selection: true,
        labelWidth: 120,
        viewBtn: true,
        dialogClickModal: false,
        column: [{
          label: "数据源",
          prop: "datasourceId",
          search: true,
          span: 24,
          type: "select",
          dicUrl: "/api/blade-develop/datasource/select",
          props: {
            label: "name",
            value: "id"
          },
          rules: [{
            required: true,
            message: "请选择数据源",
            trigger: "blur"
          }]
        }, {
          label: "模块名",
          prop: "codeName",
          search: true,
          rules: [{
            required: true,
            message: "请输入模块名",
            trigger: "blur"
          }]
        }, {
          label: "服务名",
          prop: "serviceName",
          search: true,
          rules: [{
            required: true,
            message: "请输入服务名",
            trigger: "blur"
          }]
        }, {
          label: "表名",
          prop: "tableName",
          rules: [{
            required: true,
            message: "请输入表名",
            trigger: "blur"
          }]
        }, {
          label: "表前缀",
          prop: "tablePrefix",
          hide: true,
          rules: [{
            required: true,
            message: "请输入表前缀",
            trigger: "blur"
          }]
        }, {
          label: "主键名",
          prop: "pkName",
          hide: true,
          rules: [{
            required: true,
            message: "请输入主键名",
            trigger: "blur"
          }]
        }, {
          label: "包名",
          prop: "packageName",
          overHidden: true,
          rules: [{
            required: true,
            message: "请输入包名",
            trigger: "blur"
          }]
        }, {
          label: "基础业务",
          prop: "baseMode",
          type: 'radio',
          dicUrl: "/api/blade-system/dict/dictionary?code=yes_no",
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          dataType: "number",
          hide: true,
          rules: [{
            required: true,
            message: "请选择基础业务",
            trigger: "blur"
          }]
        }, {
          label: "包装器",
          prop: "wrapMode",
          type: 'radio',
          dicUrl: "/api/blade-system/dict/dictionary?code=yes_no",
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          dataType: "number",
          hide: true,
          rules: [{
            required: true,
            message: "请选择包装器",
            trigger: "blur"
          }]
        }, {
          label: "后端生成路径",
          prop: "apiPath",
          span: 24,
          hide: true,
          rules: [{
            required: true,
            message: "请输入后端生成路径",
            trigger: "blur"
          }]
        }, {
          label: "前端生成路径",
          prop: "webPath",
          span: 24,
          hide: true,
          rules: [{
            required: true,
            message: "请输入前端生成路径",
            trigger: "blur"
          }]
        }]
      },
      data: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["permission"])), {}, {
    permissionList: function permissionList() {
      return {
        addBtn: this.vaildData(this.permission.code_add, false),
        viewBtn: this.vaildData(this.permission.code_view, false),
        delBtn: this.vaildData(this.permission.code_delete, false),
        editBtn: this.vaildData(this.permission.code_edit, false)
      };
    },
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  }),
  methods: {
    rowSave: function rowSave(row, done, loading) {
      var _this = this;

      add(row).then(function () {
        _this.onLoad(_this.page);

        _this.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate: function rowUpdate(row, index, done, loading) {
      var _this2 = this;

      update(row).then(function () {
        _this2.onLoad(_this2.page);

        _this2.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowDel: function rowDel(row) {
      var _this3 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(row.id);
      }).then(function () {
        _this3.onLoad(_this3.page);

        _this3.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    searchReset: function searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete: function handleDelete() {
      var _this4 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(_this4.ids);
      }).then(function () {
        _this4.onLoad(_this4.page);

        _this4.$message({
          type: "success",
          message: "操作成功!"
        });

        _this4.$refs.crud.toggleSelection();
      });
    },
    handleBuild: function handleBuild() {
      var _this5 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("是否生成选中模块的代码?", {
        title: "代码生成确认",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return build(_this5.ids);
      }).then(function () {
        _this5.onLoad(_this5.page);

        _this5.$message({
          type: "success",
          message: "操作成功!"
        });

        _this5.$refs.crud.toggleSelection();
      });
    },
    handleCopy: function handleCopy(row) {
      var _this6 = this;

      copy(row.id).then(function () {
        _this6.onLoad(_this6.page);

        _this6.$message({
          type: "success",
          message: "复制成功!"
        });
      });
    },
    beforeOpen: function beforeOpen(done, type) {
      var _this7 = this;

      if (["edit", "view"].includes(type)) {
        getCode(this.form.id).then(function (res) {
          _this7.form = res.data.data;
        });
      }

      done();
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this8 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.loading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(function (res) {
        var data = res.data.data;
        _this8.page.total = data.total;
        _this8.data = data.records;
        _this8.loading = false;

        _this8.selectionClear();
      });
    }
  }
};